import type { ShiftOpeningResponse } from "@/api/user/shiftOpening"

export function shiftOpeningSummary(opening: ShiftOpeningResponse | null | undefined) {
  if (!opening) return []
  const money = (value: number | null | undefined) => value == null ? "未核实" : `¥${(value / 100).toFixed(2)}`
  return [
    { label: "实际开班", value: opening.actualOpenTime || "未记录" },
    { label: "开班方式", value: opening.carryPrevious ? "承接上班统计截止" : "从实际开班开始" },
    { label: "统计期初现金", value: money(opening.openingCash) },
    { label: "空档净现金", value: money(opening.gapCash) },
    { label: "开班实点现金", value: money(opening.countedCash) },
    { label: "开班备用金变动", value: money(opening.cashMovement) },
    { label: "开班点验差额", value: money(opening.cashDifference) },
    ...(opening.cashNote ? [{ label: "开班现金说明", value: opening.cashNote }] : []),
  ]
}
